import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import RatingComponent from "react-rating";

const Rating = ({ readonly = false, initialRating = 0, stop = 5, width = 16 }) => {
  return (
    <RatingComponent
      emptySymbol={<Icon className="mr-2" width={width}  icon="solar:star-outline"  />}
      fullSymbol={<Icon className="mr-2" width={width} icon="tabler:star-filled" color="#ffe234"/>}
      readonly={readonly}
      initialRating={initialRating}
      stop={stop}
    />
  );
};

export default Rating;
